var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "actual-query-container" }, [
    _c("div", { staticClass: "actual-query-card" }, [
      _c("span", { staticClass: "actual-query-text" }, [
        _vm._v(_vm._s(_vm.query)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }